import { render, staticRenderFns } from "./TabelaProtocolo.vue?vue&type=template&id=c68a6b60&scoped=true&"
import script from "./TabelaProtocolo.vue?vue&type=script&lang=js&"
export * from "./TabelaProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./TabelaProtocolo.vue?vue&type=style&index=0&id=c68a6b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68a6b60",
  null
  
)

export default component.exports